var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0013 16.8385C4.39893 16.8385 0.667969 13.1075 0.667969 8.50521C0.667969 3.90283 4.39893 0.171875 9.0013 0.171875C13.6036 0.171875 17.3346 3.90283 17.3346 8.50521C17.3346 13.1075 13.6036 16.8385 9.0013 16.8385ZM9.0013 15.1719C12.6832 15.1719 15.668 12.1871 15.668 8.50521C15.668 4.82331 12.6832 1.83854 9.0013 1.83854C5.3194 1.83854 2.33464 4.82331 2.33464 8.50521C2.33464 12.1871 5.3194 15.1719 9.0013 15.1719ZM8.16797 4.33854H9.83463V6.00521H8.16797V4.33854ZM8.16797 7.67187H9.83463V12.6719H8.16797V7.67187Z",
    fill: "#AEB5C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.6fae9662ac76e713769c2672ccc11a12.svg";
export { ForwardRef as ReactComponent };